'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPowerSettingsNew = function MdPowerSettingsNew(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.7 8.6q5.3 4.5 5.3 11.4 0 6.3-4.4 10.6t-10.6 4.4-10.6-4.4-4.4-10.6q0-6.9 5.3-11.4l2.4 2.3q-4.3 3.6-4.3 9.1 0 4.8 3.4 8.2t8.2 3.4 8.2-3.4 3.4-8.2q0-5.5-4.3-9z m-8.1-3.6v16.6h-3.2v-16.6h3.2z' })
        )
    );
};

exports.default = MdPowerSettingsNew;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/power-settings-new.js
// module id = 1867
// module chunks = 168707334958949